import * as fn from "./fn"

export default function () {
  return { fn }
}



// WEBPACK FOOTER //
// ./src/core/plugins/samples/index.js